import React, { Component , useState} from 'react';
import Copyright from '../componentes/copyright';
import Principal from '../componentes/principal';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import {withRouter} from 'react-router-dom';
import { Container } from '@material-ui/core';
import firebase from "firebase/app";
import 'firebase/firestore';
import {authConfig} from '../auth/config';
import Cardcatmotora from './cardcatmotorista';

const classes = makeStyles((theme) => ({
   paper: {
     marginTop: theme.spacing(8),
     display: 'flex',
     flexGrow: 1,
     flexDirection: 'column',
     alignItems: 'center',
   },
   title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(20),
    },
    submit: {
      margin: theme.spacing(2, 2, 2),
  
     
  
    },
}));

document.title = 'Frota UFSM'
document.logo=''


var codunidadetransporte='';
var utipo='';
var depnome='';
export const  Parametrosupervisor = withRouter(({history}) => {
   
  const [state, setState] = useState([]);

   React.useEffect(() => {
    
   

    async function pegauser() {
      const user = authConfig.auth().currentUser;
       var db = firebase.firestore();
       var userref =  db.collection("usuarios").doc(user.uid);         
       console.log("esta aqui 001");
      await userref.get().then((doc) => {       
         if (doc.exists) {
           console.log("Document data pegouppqpq:", doc.data());
           utipo = doc.data().usertipo;
           codunidadetransporte = doc.data().codunidadetransporte;
           
            pegalista();
         }else{
           alert('Não encontramos o seu cadastro')
         }
        
        }).catch(function(error) {
          alert("Erro ao localizar o seu cadastro ", error.message);
          })
    };

    async function pegalista() {          
      
            if(utipo==10) {
             console.log("user tipo poxa"+ codunidadetransporte + "puta merda");
             var db = firebase.firestore();
             var query = await db.collection("categoriasmotorista").get()
             .then(function(querySnapshot) {
        
              querySnapshot.forEach(function(doc) {
                var listausers=[];
                  listausers.push({id: doc.id, catmotorista: doc.data().catmotorista,
                    valoralmoco:doc.data().valoralmoco, valorcafe: doc.data().valorcafe, valorhora50: doc.data().valorhora50, valorhora100: doc.data().valorhora100,
                  valorespera:doc.data().valorespera, valorsobreaviso:doc.data().valorsobreaviso, valoradicionalnoturno: doc.data().valoradicionalnoturno,
                    valorjanta: doc.data().valorjanta, valorbanho: doc.data().valorbanho, valorpernoite: doc.data().valorpernoite,
                    valoralmocofaturado:doc.data().valoralmocofaturado, valorcafefaturado: doc.data().valorcafefaturado, valorhora50faturado: doc.data().valorhora50faturado, valorhora100faturado: doc.data().valorhora100faturado,
                  valoresperafaturado:doc.data().valoresperafaturado, valorsobreavisofaturado:doc.data().valorsobreavisofaturado, valoradicionalnoturnofaturado: doc.data().valoradicionalnoturnofaturado,
                    valorjantafaturado: doc.data().valorjantafaturado, valorbanhofaturado: doc.data().valorbanhofaturado, valorpernoitefaturado: doc.data().valorpernoitefaturado,
                  });
                console.log("veiculos pqp ", state );
               setState (currentArray => [...currentArray, listausers]);
               

     
              });
              
                      
            })
           .catch(error => {
               console.log('Não encontramos categorias cadastradas', error);
               alert("'Não encontramos categorias cadastrados'");
           });
           
           }
     
           
         
    
      
    }
 
    pegauser()
    
  
  
  console.log('agora sim é o tamanho ', state.length);
  }, []); 

  
 
return(
 
<Container >
<CssBaseline />
      
      <div id="cabeça" >
      <Principal/>
      
      
      </div>
      
      <Typography className={classes.title} variant="h5" noWrap align="center">
            Categorias Motorista
          </Typography>
          
      <div id="corpo"   align="center" className={classes.paper} >

      

         <div id="corpoveiculo">
           <Container maxWidth="xs">
            
             
             {state.map(item=>(
              
             <Cardcatmotora props={item} key={item.id} />
               
             ))}

             </Container>
           </div>
          
          
      </div>
       
  
       <Box mt={3}>
          <Copyright/>
       </Box>
   
   
   </Container>
)

}

)
 
export default Parametrosupervisor;
